import { create_user_path, share_article_path } from '@routes';
import { trackLeadInGa } from '@tracking';

import request from './request';

export const LEAD_CREATED_EVENT = 'lead_created';
export const LEAD_CONVERSION_EVENT = 'lead-conversion';
export const DEFAULT_ORGANIC_LEAD_TYPE = 'organic';
const CALL_LOCATION = 'email_lead_capture';

export interface LeadDetails {
  article_title?: string;
  briefing_title?: string;
  newsletter_name?: string;
  org_chart_title?: string;
  homepage_conversion?: boolean;
  project_name?: string;
}

export interface CreateLeadParams {
  article_id?: number;
  briefing_guid?: string;
  force_email_auth: boolean;
  newsletter_id?: number;
  newsletter_ids?: number[];
  redirect_to_on_success?: string;
  user: {
    declined_opt_in?: boolean;
    email: string;
    form_location: string;
    lead_type: string;
    opt_in_required?: boolean;
    page: string;
  };
}

export interface CreateLeadResponse {
  location?: string;
  new_lead?: boolean;
  user_id?: number;
}

export const createLead = async (
  params: CreateLeadParams,
  leadDetails: LeadDetails
): Promise<CreateLeadResponse> => {
  const resp = await request('post', create_user_path(), params);
  if (resp?.new_lead) {
    trackLead(params.user.email, params.user.lead_type, leadDetails);
  }
  return resp;
};

export const createLeadByUnlockContent = async (
  params: CreateLeadParams,
  leadDetails: LeadDetails
): Promise<CreateLeadResponse> => {
  const resp = await request('post', share_article_path(), params);
  if (resp?.new_lead) {
    trackLead(params.user.email, params.user.lead_type, leadDetails);
  }
  return resp;
};

const trackLead = (email: string, leadType: string, leadDetails: LeadDetails) => {
  window.trackAhoyEventOnly(LEAD_CONVERSION_EVENT, { email: email, call_location: CALL_LOCATION });
  trackLeadInGa(leadType, leadDetails);
};
